export default __webpack_public_path__ + "bg-holiday.41a97b.jpg";